import React, { useState } from "react";
import telegramupApi from "./telegramupApi";
import "./WalletModal.css";

const MIN_DEPOSIT = 50;

export default function DepositModal({ onClose, onSuccess }) {
  const [step, setStep] = useState("amount"); // amount -> method -> pay -> done
  const [amount, setAmount] = useState("");
  const [method, setMethod] = useState(null);
  const [merchantPhone, setMerchantPhone] = useState("");
  const [smsText, setSmsText] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [resultMsg, setResultMsg] = useState("");

  const handleAmountNext = () => {
    const amt = parseFloat(amount);
    if (!amt || amt < MIN_DEPOSIT) {
      setError(`Minimum deposit is ${MIN_DEPOSIT} ETB`);
      return;
    }
    setError("");
    setStep("method");
  };

  const handleChooseMethod = async (m) => {
    setMethod(m);
    setLoading(true);
    setError("");
    try {
      const data = await telegramupApi.initiateDeposit(parseFloat(amount), m);
      setMerchantPhone(data.merchant_phone);
      setStep("pay");
    } catch (err) {
      setError(
        err.response?.data?.detail ||
          err.message ||
          "Failed to start deposit. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleConfirm = async () => {
    if (!smsText.trim()) {
      setError("Please paste the SMS or transaction ID");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const data = await telegramupApi.confirmDeposit(smsText.trim());
      if (data.status === "matched") {
        setResultMsg(
          `✅ Payment confirmed! ${data.amount} ETB added to your wallet.`
        );
        setStep("done");
        onSuccess && onSuccess();
      } else if (data.status === "player_verified") {
        setResultMsg("✅ SMS received! Your payment is being verified.");
        setStep("done");
      } else if (data.status === "duplicate_txn") {
        setError("⚠️ This SMS/transaction has already been used.");
      } else {
        setError(data.message || "Could not match this SMS. Please try again.");
      }
    } catch (err) {
      setError(
        err.response?.data?.detail ||
          err.message ||
          "Failed to confirm deposit. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="wm-overlay" onClick={onClose}>
      <div className="wm-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="wm-header">
          <h3>💰 Deposit</h3>
          <button className="wm-close" onClick={onClose}>✕</button>
        </div>

        {error && <div className="wm-error">{error}</div>}

        {step === "amount" && (
          <div className="wm-body">
            <label className="wm-label">Amount (ETB)</label>
            <input
              className="wm-input"
              type="number"
              placeholder={`Min ${MIN_DEPOSIT} ETB`}
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              autoFocus
            />
            <button className="wm-btn wm-btn--primary" onClick={handleAmountNext}>
              Next
            </button>
          </div>
        )}

        {step === "method" && (
          <div className="wm-body">
            <p className="wm-text">Amount: <b>{amount} ETB</b></p>
            <label className="wm-label">Choose payment method</label>
            <div className="wm-method-row">
              <button
                className="wm-method-btn"
                disabled={loading}
                onClick={() => handleChooseMethod("telebirr")}
              >
                📱 Telebirr
              </button>
              <button
                className="wm-method-btn"
                disabled={loading}
                onClick={() => handleChooseMethod("cbebirr")}
              >
                🏦 CBE Birr
              </button>
            </div>
            {loading && <p className="wm-text">Please wait...</p>}
          </div>
        )}

        {step === "pay" && (
          <div className="wm-body">
            <p className="wm-text">
              1. Send <b>{amount} ETB</b> to this {method === "telebirr" ? "Telebirr" : "CBE Birr"} account:
            </p>
            <div className="wm-phone-box">{merchantPhone}</div>
            <p className="wm-text">
              2. After sending, paste the confirmation SMS or transaction ID below:
            </p>
            <textarea
              className="wm-textarea"
              placeholder="Paste SMS text or transaction ID..."
              value={smsText}
              onChange={(e) => setSmsText(e.target.value)}
              rows={4}
            />
            <button
              className="wm-btn wm-btn--primary"
              onClick={handleConfirm}
              disabled={loading}
            >
              {loading ? "Confirming..." : "Confirm Deposit"}
            </button>
          </div>
        )}

        {step === "done" && (
          <div className="wm-body">
            <div className="wm-success">{resultMsg}</div>
            <button className="wm-btn wm-btn--primary" onClick={onClose}>
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
